import { Inject, Injectable, InjectionToken, NgZone } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { EnvironmentService } from '../../singleton-services/environment.service'
import { Observable, timer, EMPTY } from 'rxjs'
import { PlatformService } from '../../singleton-services/platform.service'
import { flatMap, takeUntil } from 'rxjs/operators'

export const HEARTBEAT_MILLI_SECONDS = new InjectionToken<number>('cfg.vid.heartbeat')

@Injectable()
export class HeartbeatService {
  constructor(
    private http: HttpClient,
    private es: EnvironmentService,
    private ps: PlatformService,
    private zone: NgZone,
    @Inject(HEARTBEAT_MILLI_SECONDS) private heartbeatSeconds: number
  ) {}

  /**
   * Every n seconds (normally 60 seconds) the player should submit a
   * heartbeat. This will serve for reporting purposes to sort of say "I'm
   * still watching," but it will also check if the token is still valid. If
   * the API returns anything outside of the 200 range, the player should
   * immediately stop the stream from playing and display the provided error
   * message to the user with instructions on how to proceed.
   *
   * 202: SuccessfulNoContent
   * 400: InvalidApiRequest
   * 401: InvalidUserCredentials
   * 403: PermissionDenied
   * 404: TokenOrStreamNotFound
   * 409: UserBumped
   * 429: ApplicationThrottled
   */
  readonly postHeartbeat = (tokenId: string) =>
    this.http.post(`${this.es.config.endpoints.live}/tokens/${tokenId}/heartbeat`, {})

  readonly beginTrackingViewTime = (tokenId: string, cancellationStream: Observable<void>) =>
    this.ps.isServer
      ? EMPTY
      : this.zone.runOutsideAngular(() =>
          timer(0, this.heartbeatSeconds).pipe(
            flatMap(() => this.postHeartbeat(tokenId)),
            takeUntil(cancellationStream)
          )
        )
}
